import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { User } from '../_models/user';
import { AuthenticationService } from '../_services/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.authenticationService.currentUserValue;
        if (currentUser) {
            let spliturl = state.url.split("/");
            let url = spliturl[1];
            let permission = localStorage.getItem('userPermissions');
            
            // check if route is restricted by role
            if (permission && permission.indexOf(url) === -1) {
                
                // role not authorised so redirect to home page
                if(url == 'dashboard'){
                    this.authenticationService.logout()
                    this.router.navigate(['/auth/login']);
                    return false;
                }else{
                     this.router.navigate(['/dashboard/default']);
                     return false;
                }
            }else if(!permission){
                this.authenticationService.logout()
                this.router.navigate(['/auth/login']);
                return false;
            }
            // authorised so return true
            return true;
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
}